export default "__VITE_ASSET__BkxyyNzP__"